import templates from '@mfe/components/templates';
import { config } from '@mfe/config';
import { configStore } from '@mfe/store';
import { TemplatingMixin } from '@mfec/lit/mixins/TemplatingMixin';
import { TriggerEventMixin } from '@mfec/lit/mixins/TriggerEventMixin';
import { TemplateTheme } from '@mfec/lit/TemplateResolver';
import { LitElement } from 'lit';

export class BaseComponent extends TemplatingMixin(TriggerEventMixin(LitElement, config.componentTagName), configStore.theme, templates) {
  constructor() {
    super();
    // This is important to support multiple themes (occl/tefOne).
    // If the theme gets changed in the configStore we must re-initialize the TemplateResolver,
    // otherwise it would stay on the theme default (which is "occl" here)
    configStore.subscribe((_, theme) => { this.setTemplatingTheme(theme as TemplateTheme); }, 'theme');
  }
}
